import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { defaultPitchBreakdownFilter } from 'yankees-react-utils';
import Header from './Header';
import Filters from './Filters';
import Charts from './Charts';
import usePlayerSelector from '../../../../utils/usePlayerSelector';

const BatTracking = ({ playerId, defaultLevelId }) => {
    const player = usePlayerSelector();
    const isSwitch = player.Bats === 3;
    const defaultBatterHand = useMemo(() => (player.Bats === 3 ? 2 : player.Bats || 2), [player.Bats]);
    const [filter, setFilter] = useState({
        ...defaultPitchBreakdownFilter,
        pitcherHand: 1,
        batterHand: defaultBatterHand,
    });
    const [levels, setLevels] = useState([]);

    useEffect(() => {
        setFilter((prev) => ({
            ...prev,
            pitcherHand: 1,
            batterHand: defaultBatterHand,
        }));
    }, [playerId, defaultBatterHand]);

    return (
        <div>
            <Header
                playerId={playerId}
                defaultLevelId={defaultLevelId}
                filter={filter}
                setFilter={setFilter}
                levels={levels}
                setLevels={setLevels}
            />
            <Filters filter={filter} setFilter={setFilter} isSwitch={isSwitch} />
            <Charts playerId={playerId} filter={filter} levels={levels} />
        </div>
    );
};

BatTracking.propTypes = {
    playerId: PropTypes.number.isRequired,
    defaultLevelId: PropTypes.number,
};

BatTracking.defaultProps = {
    defaultLevelId: null,
};

export default BatTracking;
